module.exports = __webpack_public_path__ + "static/img/icon-lab-04.5bbd5d27.png";